import { useSDK } from '@littlebird/sdk';
import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

import { FEATURES, useFeature } from '@/features/feature-flags';
import { inElectron } from '@/utils/capabilities';

import {
  formatImportSummary,
  useChatGptImportStatusQuery,
} from './chatgpt-import.query';

/** Mounted once per main window, so an import that finishes anywhere in the app is reported exactly once */
export function ChatGptImportWatcher() {
  const sdk = useSDK();
  const hasFeature = useFeature();
  const query = useChatGptImportStatusQuery({
    enabled: inElectron() && hasFeature(FEATURES.CHATGPT_EXPORT),
    poll: true,
  });

  // The import writes chats on the server, so a completed import also syncs
  // once to show them
  const status = query.data?.status;
  const result = query.data?.result ?? null;
  const previousStatus = useRef(status);
  useEffect(() => {
    if (previousStatus.current === 'running') {
      if (status === 'completed') {
        void sdk.syncNow();
        toast.success('ChatGPT import finished', {
          description: formatImportSummary(result),
        });
      } else if (status === 'failed') {
        toast.error('ChatGPT import didn’t finish', {
          description: 'Try again in a moment.',
        });
      }
    }
    previousStatus.current = status;
  }, [sdk, status, result]);

  return null;
}
